import { render, staticRenderFns } from "./UpcomingShows.vue?vue&type=template&id=7475d8a1&scoped=true&"
import script from "./UpcomingShows.vue?vue&type=script&lang=js&"
export * from "./UpcomingShows.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingShows.vue?vue&type=style&index=0&id=7475d8a1&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7475d8a1",
  null
  
)

export default component.exports